var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgMenuBack = function SvgMenuBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 21.18L5.347 12 14 2.82 11.336 0 0 12l11.336 12z",
    fillRule: "evenodd"
  })));
};

export default __webpack_public_path__ + "static/media/menu-back.58eeb5b2.svg";
export { SvgMenuBack as ReactComponent };